<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><i>For Daniel McDonald Roberts.<br/>He conveyed to me both his name and<br/>a passion for the historical quest</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f81d679e